export default {"src":"/_next/static/media/shopping-cart.49bc0a79.svg","height":28,"width":29,"blurWidth":0,"blurHeight":0};